<template>
  <cTable ref="table" :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config">
    <template #DETAILS="{ visible, params }">
      <Tracker v-if="visible" :statusId="params.row.airway_number"></Tracker>
    </template>
  </cTable>
</template>

<script>
import { getPackList, getTransferList } from "@/api/storage/packList";
import { getWarehouse } from "@/api/storage/warehouse";
import { getAllClient } from "@/api/user/client";
import { getSelectType } from "@/api/public";
import cTable from "@/base/common/index";
import Tracker from "@/base/order_tracker";
import { getUser } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";

export default {
  name: "transferList",
  components: {
    cTable,
    Tracker,
  },
  async mounted() {
    let data = await this.$sel.getData([
      "EXPRESS_DELIVERY_TYPE",
      "OMS_PICKUP_STATUS",
    ]);
    this.pickinglist = this.$sel.ToObj(data["OMS_PICKUP_STATUS"]);
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "warehouse_id")
        item.options = (await getWarehouse()).data.payload.rows;
      if (item.key === "type") item.options = data["EXPRESS_DELIVERY_TYPE"];
      if (item.key === "statusFlag") item.options = data["OMS_PICKUP_STATUS"];
      if (item.key === "service_id")
        item.options = (
          await getUser({ standard: "CustomerService" })
        ).data.payload.rows;
      if (item.key === "to_country")
        item.options = (await getCountry()).data.payload.rows;
    });
  },
  methods: {
    handleTab(tab) {
      console.log(this);
      this.$refs["table"].tabName = this.tabName;
      this.$refs["table"].getList();
    },
  },
  data() {
    let pickingSel = [
      { label: this.$t("Wait_Picking"), value: 0 },
      { label: this.$t("Picking"), value: 2 },
      { label: this.$t("completed"), value: 1 },
    ],
      pickinglist = [
        { label: this.$t("Wait_Picking"), value: 0 },
        { label: this.$t("completed"), value: 1 },
        { label: this.$t("Picking"), value: 2 },
      ],
      bagSel = [
        { label: this.$t("original_shelves"), value: 1 },
        { label: this.$t("unpack_sheves"), value: 2 },
        { label: this.$t("self_mention"), value: 3 },
        { label: this.$t("destroy"), value: 4 },
        { label: this.$t("system_shelf"), value: 5 },
      ],
      bagType = [
        { label: this.$t("no_plan"), value: 0 },
        { label: this.$t("original_shelves"), value: 1 },
        { label: this.$t("unpack_sheves"), value: 2 },
        { label: this.$t("self_mention"), value: 3 },
        { label: this.$t("destroy"), value: 4 },
        { label: this.$t("system_shelf"), value: 5 },
      ];
    return {
      pickinglist: {},
      methods: {
        list: getTransferList,
        // getDetails
      },
      config: {
        height: 630,
      },
      modals: {
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600,
            },
          },
          footer: { show: () => false },
        },
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm["endTime"] = time;
                }
              },
            },
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "service_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "warehouse_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            options: [],
            config: { label: "title", value: "id" },
          },
          {
            key: "statusFlag",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("orderType");
            },
            options: [],
          },
          {
            key: "to_country",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            options: [],
            config: { label: "code", value: "code" },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          align: "center",
          component: "Button",
          copy: true,
          header: {
            copy: true, //头部复制
          },
          minWidth: 160,
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            click({ row }) {
              this.$page.getModal("showDetails").setTitle(row.airway_number);
              this.$page.getModal("showDetails").open({ row });
            },
          },
        },
        {
          name: () => this.$t("ori_pack_cnb"),
          key: "sku_name",
          align: "center",
          header: {
            copy: true, //头部复制
          },
          showOverflow: false,
          minWidth: 100,
        },
        {
          name: () => this.$t("orderType"),
          key: "status_flag",
          align: "center",
          minWidth: 100,
          render: (h, { row }) => {
            return h(
              "span",
              { style: { color: row.status_flag == "2" ? "red" : "" } },
              this.$sel.keyMap(this.pickinglist, row.status_flag)
            );
          },
          methods: {
            render: ({ value }) => {
              return this.$sel.keyMap(this.pickinglist, value);
            },
          },
        },
        {
          name: () => this.$tz("计费状态"),
          key: "is_calculated",
          minWidth: 110,
          methods: {
            render({ value }) {
              return this.$tz(
                value == 0 ? "待计费" : value == 1 ? "计费成功" : "计费失败"
              );
            },
          },
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          header: {
            copy: true, //头部复制
            noFilter: true,
          },
          minWidth: 100,
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "service_name",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 100,
          width: 180,
        },
        {
          name: () => this.$t("outboundTime"),
          key: "send_time",
          align: "center",
          minWidth: 180,
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouseTitle",
          align: "center",
          minWidth: 100,
        },
      ],
    };
  },
};
</script>
